import { configurationToProjectJson, projectJsonToConfiguration } from '@/domain/template/templateSerialisation';
import { getEmptyTemplateConfiguration } from '@/utils/emptyTemplate';
import type { ITemplate } from '@/domain/template/ITemplate';
import type { ITemplateDTO } from '@/domain/template/ITemplateDTO';

// Transport mapping: the DTO the API exchanges, and the file URLs it addresses. Kept next to
// apiFetch because both prefix VITE_API_URL — the domain must not know about either.

function thumbnailFileIdToUrl(thumbnailFileId: string): string {
    return `${import.meta.env.VITE_API_URL}/template-files/${thumbnailFileId}`;
}

function templateToDTO(template: ITemplate): ITemplateDTO {
    return {
        id: template.id,
        thumbnail: template.thumbnailFileId,
        name: template.name,
        projectJson: configurationToProjectJson(template.configuration),
    };
}

function DTOToTemplate(dto: ITemplateDTO): ITemplate {
    return {
        id: dto.id,
        thumbnailUrl: dto.thumbnail ? thumbnailFileIdToUrl(dto.thumbnail) : '',
        thumbnailFileId: dto.thumbnail,
        name: dto.name,
        // A projectJson that is an array is the shape of a much older save; there is nothing to
        // read from it, so the editor opens on an empty configuration.
        configuration: Array.isArray(dto.projectJson)
            ? getEmptyTemplateConfiguration()
            : projectJsonToConfiguration(dto.projectJson as Record<string, unknown>),
    };
}

export { DTOToTemplate, templateToDTO, thumbnailFileIdToUrl };
